// extracted by mini-css-extract-plugin
export var emailBlockLink = "_q4-0";